import React, { memo } from 'react';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
// @ts-ignore
import ProgressTag from '@gp/components/ProgressTag';
import moment from 'moment';
import { formatMilestoneDateByStatus } from '@gp/utils/milestone';
import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';
import type { MilestoneDateStatus } from '@gp/enums/milestone';
import LinkJump from '@gp/components/LinkJump';
import { isIncludeConsole, queryJumpable } from '@gp/utils/common';
import { toProjectDetails, toProjectDetailsByGameType } from '@gp/utils/project';

type dataType = {
  img_url: string;
  name: string;
  platform: any;
  progress: string;
  genre: string;
  next_checkpoint: string;
  next_date_confirm: MilestoneDateStatus;
  next_checkpoint_date: string;
  priority: string;
} | null;
interface InDevCardPropsType {
  style?: React.CSSProperties;
  data: dataType;
}

const DEFAULT_PROPS: InDevCardPropsType = {
  style: {},
  data: null,
};

function InDevCard(props: InDevCardPropsType) {
  const { style, data, projects } = props;
  const { platform } = data;

  const toDetails = (e: any, isJump = false) => {
    const { id = '', name = '', platform } = data || {};
    const params = {
      id,
      name,
      tab: 'gameDetail',
      platform,
    } as any;
    return toProjectDetailsByGameType(params, e, isJump, projects);
  };

  const platformLowerCase =
    (Array.isArray(platform)
      ? platform.join(',')?.toLowerCase()
      : platform?.trim()?.toLowerCase()) || '';
  return (
    <div className="overview-in-dev-card" style={style}>
      <div className="card-header">
        <LinkJump url={toDetails(null, false)}>
          <GeneralImageNew
            domain="game"
            width={40}
            height={40}
            style={{ borderRadius: '8px' }}
            src={data?.img_url || ''}
            onClick={(e: React.MouseEvent<Element, MouseEvent>) => {
              if (!queryJumpable(e)) return;
              toDetails?.(e, true);
            }}
          />
        </LinkJump>
        <div className="header-info">
          <div className="header-top">
            <LinkJump url={toDetails(null, false)}>
              <div
                className="header-top-left dbg-no-action-blue"
                onClick={(e: React.MouseEvent<Element, MouseEvent>) => {
                  if (!queryJumpable(e)) return;
                  toDetails?.(e, true);
                }}
              >
                <EllipsisTextBubble
                  text={data?.name || '-'}
                  bubbleStyle={{
                    height: 20,
                    lineHeight: '20px',
                    marginRight: '4px',
                  }}
                />
              </div>
            </LinkJump>
            <ProgressTag className="card-title-label font14" progress={data?.progress} />
          </div>
          <div className="platform-group-box">
            <div className="platform-group">
              {(platformLowerCase?.toLowerCase() === 'all platforms' ||
                platformLowerCase?.toLowerCase().includes('mobile')) && (
                <SvgIcon type="other-icon" className="platform-group-icon" />
              )}
              {(platformLowerCase?.toLowerCase() === 'all platforms' ||
                platformLowerCase?.toLowerCase().includes('pc')) && (
                <SvgIcon type="monitor" className="platform-group-icon" />
              )}
              {(platformLowerCase?.toLowerCase() === 'all platforms' ||
                isIncludeConsole(platformLowerCase)) && (
                <SvgIcon type="game" className="platform-group-icon" />
              )}
            </div>
            <div className="header-sign">
              {data?.genre?.split(/[|\\/]/)?.map((t: string) => {
                return t ? (
                  <label key={t} className="game-type-sign">
                    {t || '-'}
                  </label>
                ) : null;
              })}
            </div>
          </div>
        </div>
      </div>
      <article className="card-footer">
        <span className="footer-label">Next Milestone:&nbsp;</span>
        {!(moment(data?.next_checkpoint_date).isValid() && data?.next_checkpoint_date) &&
        !data?.next_checkpoint ? (
          '-'
        ) : (
          <>
            <div>
              <EllipsisTextBubble
                text={data?.next_checkpoint || '-'}
                style={{ color: '#888', fontSize: 14 }}
              />
            </div>
            &nbsp;(
            <span className="footer-date">
              {moment(data?.next_checkpoint_date).isValid() && data?.next_checkpoint_date
                ? formatMilestoneDateByStatus(data?.next_checkpoint_date, data?.next_date_confirm)
                : '-'}
            </span>
            )
          </>
        )}
      </article>
    </div>
  );
}

InDevCard.defaultProps = DEFAULT_PROPS;

export default memo(InDevCard);
